import { Box, Card, CardContent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useTranslation } from "react-i18next";
import { usePayableInvoicesRepository } from "../../../api/repositories/PayableInvoicesRepository";
import PayableInvoiceDetails from "./PayableInvoicesDetails";

const PayableInvoicePreview = () => {

    const { id } = useParams();
    const { getPayableInvoiceById } = usePayableInvoicesRepository();

    const navigate = useNavigate();
    const { t } = useTranslation("finance", { keyPrefix: "payable-invoices" });

    const [invoice, setInvoice] = useState<any>(undefined);

    useEffect(() => {
        if (id) {
            getPayableInvoiceById(id).then((data) => {
                setInvoice(data.result);
            }, () => navigate('/finance/invoices-payable'));
        } else {
            navigate('/finance/invoices-payable');
        }
    }, []);

    return (
            <Card variant="outlined" sx={{ margin: '15px' }}>
                <CardContent>
                    <Box style={{ display: 'flex', alignItems: 'center', gap: '1ch' }}>
                        {/*<ArrowBackRoundedIcon onClick={() => {*/}
                        {/*    navigate('/finance/invoices-payable');*/}
                        {/*}}/>*/}
                        <Typography variant={'body1'} fontWeight={'bold'}>
                            {t('preview.buttons.back', { invoiceNumber: invoice?.invoiceNumber })}
                        </Typography>
                    </Box>
                    {invoice && <PayableInvoiceDetails invoice={invoice} editable={false} preview={false}/>}
                </CardContent>
            </Card>
    )
}
export default PayableInvoicePreview;